import { render, staticRenderFns } from "./FormGroupedCourseSelect.vue?vue&type=template&id=028ed7c8&"
import script from "./FormGroupedCourseSelect.vue?vue&type=script&lang=js&"
export * from "./FormGroupedCourseSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports